var map = {
	"./Workspace-min.png": "6a56",
	"./acuity.png": "c902",
	"./icon (1).png": "f7de",
	"./icon (2).png": "fdaf",
	"./icon (3).png": "4301",
	"./icon (4).png": "70e9",
	"./icon (5).png": "e57e",
	"./webAndMobile.png": "1a7b",
	"./样机-2-min.png": "79c2",
	"./样机-min.png": "084b",
	"./编组 8-min.png": "c2ee",
	"./背景-2.png": "359b",
	"./背景-min.png": "804c",
	"./背景备份-min.png": "2d14"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "52bd";